import { Component, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IResponseCode } from '../../../core/interfaces/response-code';
import { ResponseCodeDatasource } from '../../../core/datasource/response-code-datasource';
import { JsonEditorOptions, JsonEditorComponent } from 'ang-jsoneditor';
import { Title } from '@angular/platform-browser';
import { Span, RowSpanComputer } from '../../../core/common/row-span-computer';
import { IUserInformation } from '../../../core/interfaces/user/user-information';
import { LocalStorageService } from '../../../core/services/local-storage.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  public properties: BehaviorSubject<IResponseCode[]> = new BehaviorSubject<IResponseCode[]>(this.getData());
  public dataSource: ResponseCodeDatasource | null;
  public displayedColumns = ["code", "message", "description"];

  public jsonEditor: any;
  public response = "The voice call with Id = 'd030a297-d488-47ca-aa06-f6de67e9694c' has already been archived."

  public csharpCode: any;
  public jsCode: any;
  public pythonCode: any;
  public javaCode: any;

  public userInfo: IUserInformation = null;


  public editorOptions: JsonEditorOptions;
  @ViewChild(JsonEditorComponent) jsonTextEditor: JsonEditorComponent;

  rowSpans: Array<Span[]>;

  private rowSpanComputer = new RowSpanComputer();

  constructor(private title: Title,
    private localStorageService: LocalStorageService)
  {
    this.title.setTitle("Dillo Docs | Hangup Call");
    this.editorOptions = new JsonEditorOptions();
    this.editorOptions.mode = 'code';

    this.userInfo = this.localStorageService.getUserInfo();
  }


  ngOnInit() {

    this.initialiseCodeSamples();

    this.dataSource = new ResponseCodeDatasource(this.properties);

    this.computeRowSpans();
  }

  private computeRowSpans(): void {
    this.rowSpans = this.rowSpanComputer.compute(this.properties.value, this.displayedColumns);
  }

  public spellColumnDisplayName(columnName: string) {

    switch (columnName) {
      case 'code': {
        return 'Status';
      }

      case 'message': {
        return 'Message';
      }

      case 'description': {
        return 'Description';
      }
    }
  }


  getData(): IResponseCode[] {
    return [
      {code:"200 OK", message:'', description:" The call was successfully ended"},
      { code: "404  Not found", message:"SendAction type = Voice - id = {your request id} not found", description:"The id send as parameter in HTTP request it is not valid"},
      {code:'400 Bad Request', message:"The voice call with Id = '{your request id}' has already been archived", description:'The call has ended and has a final status.'},
      { code: '400 Bad Request', message: "The voice call with Id = '{ your request id }' has already ended", description:"The voice call is ended and will be archived"},
      { code: '400 Bad Request', message: "The voice call with Id = '{ your request id }' is still pending, but it has not started yet", description:"The voice call request was just send or is ringing."},
    ]
  }


  initialiseCodeSamples() {
        this.csharpCode = `var client = new RestClient("https://api.dillo.cloud/api/voice/outbound/hangup/c6eda3a3-f500-4a85-abc5-93f49f4b8542");
    client.Timeout = -1;
    var request = new RestRequest(Method.GET);
    request.AddHeader("CustomerCode", "${this.userInfo.customerCode != null ? this.userInfo.customerCode : "[your customer code]"}");
    request.AddHeader("ApiKey", "${this.userInfo.apiKey != null ? this.userInfo.apiKey : "[your api key]"}");
    request.AddHeader("Content-Type", "application/json");
    request.AddParameter("application/json", "",  ParameterType.RequestBody);
    IRestResponse response = client.Execute(request);
    Console.WriteLine(response.Content);`;


        this.jsCode = `var settings = {
      "url": "https://api.dillo.cloud/api/voice/outbound/hangup/c6eda3a3-f500-4a85-abc5-93f49f4b8542",
      "method": "GET",
      "timeout": 0,
      "headers": {
        "CustomerCode": "${this.userInfo.customerCode != null ? this.userInfo.customerCode : "[your customer code]"}",
        "ApiKey": "${this.userInfo.apiKey != null ? this.userInfo.apiKey : "[your api key]"}",
        "Content-Type": "application/json"
      },
    };

    $.ajax(settings).done(function (response) {
      console.log(response);
    });`;


        this.javaCode = `OkHttpClient client = new OkHttpClient().newBuilder()
      .build();
    Request request = new Request.Builder()
      .url("https://api.dillo.cloud/api/voice/outbound/hangup/c6eda3a3-f500-4a85-abc5-93f49f4b8542")
      .method("GET", null)
      .addHeader("CustomerCode", "${this.userInfo.customerCode != null ? this.userInfo.customerCode : "[your customer code]"}")
      .addHeader("ApiKey", "${this.userInfo.apiKey != null ? this.userInfo.apiKey : "[your api key]"}")
      .addHeader("Content-Type", "application/json")
      .build();
    Response response = client.newCall(request).execute();`;

        this.pythonCode = `import http.client
    import mimetypes
    conn = http.client.HTTPSConnection("api.dillo.cloud")
    payload = ''
    headers = {
      'CustomerCode': '${this.userInfo.customerCode != null ? this.userInfo.customerCode : "[your customer code]"}',
      'ApiKey': '${this.userInfo.apiKey != null ? this.userInfo.apiKey : "[your api key]"}',
      'Content-Type': 'application/json'
    }
    conn.request("GET", "/api/voice/outbound/hangup/c6eda3a3-f500-4a85-abc5-93f49f4b8542", payload, headers)
    res = conn.getresponse()
    data = res.read()
    print(data.decode("utf-8"))`;
  }
}
